import { useEffect, useState } from "react"
import useAnalytics from "@mkt/ui/hooks/useAnalytics"

const useGlobalError = () => {
  const { globalError, setGlobalError } = useAnalytics()
  const [isOpenToast, toggleToast] = useState(false)
  const [message, setMessage] = useState(
    "Estamos passando por instabilidade. Tente novamente mais tarde!"
  )

  function closeToast() {
    toggleToast(false)
    setGlobalError(false)
  }

  useEffect(() => {
    if (globalError) {
      toggleToast(globalError)
    }
  }, [globalError])

  return {
    closeToast,
    isOpenToast,
    message,
    setMessage,
    toggleToast,
  }
}

export default useGlobalError
